<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Sale from '@/components/widgets/sale'
import SaleService from '@/services/sale'

export default {
  page: {
    title: "Pedidos",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, Sale },
  data() {
    return {
      title: "Pedidos",
      sales: [],
      searchValue: '',

      count: 0,
      currentCount: 0,
      currentPage: 1,
      totalPages: 0,
      perPage: 0,
      startIndex: 0,
      endIndex: 0,
    };
  },
  computed: {
    rows() {
      return this.sales.length;
    }
  },
  mounted() {
    this.load(1);
  },
  sockets: {
    // newSale() {
    //   // eslint-disable-next-line no-console
    //   console.log('socket recebido');

    //   this.load(1, true);
    //   this.$toast.open('Novo Pedido');
    // }
  },
  methods: {
    load(page, hideLoading = false) {
      let loader;
      if (!hideLoading) {
        loader = this.$loading.show();
      }

      SaleService.getSales(page, this.searchValue).then(res => {
        if (!hideLoading) {
          loader.hide();
        }

        this.sales = res.data.data;

        this.count = res.data.count;
        this.currentCount = res.data.currentCount;
        this.currentPage = res.data.currentPage;
        this.totalPages = res.data.totalPages;
        this.perPage = res.data.perPage;
        this.startIndex = res.data.startIndex;
        this.endIndex = res.data.endIndex;
      }).catch(() => {
        if (!hideLoading) {
          loader.hide();
        }
      })
    },
    search() {
      this.load(1);
    },
    onPageChange() {
      this.load(this.currentPage);
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-6">
                <div class="position-relative search-input search-box">
                  <form @submit.prevent="search" class="align-items-center">
                    <input
                      type="text"
                      class="form-control"
                      v-model="searchValue"
                      placeholder="Procurar por código ou cliente..."
                    />

                    <button type="submit" class="btn btn-rounded btn-outline-primary ml-2">
                      Pesquisar
                    </button>
                  </form>
                </div>
              </div>
            </div>

            <Sale :sales="sales" :loadProducts="this.load" />
            
            <div class="row justify-content-md-between align-items-md-center mt-4">
              <div class="col-xl-7">Mostrando {{startIndex}} - {{endIndex}} de {{count}}</div>

              <div class="col-xl-5">
                <div class="text-md-right float-xl-right mt-2 pagination-rounded">
                  <b-pagination
                    v-model="currentPage" 
                    :total-rows="count"
                    :per-page="perPage"
                    @input="onPageChange"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss">
  .search-box form {
    display: flex;
    flex-direction: row;
  }

  .search-box .form-control {
    padding-left: 20px;
  }

  .input-search {
    width: 90%;
  }
</style>